import React from 'react';

interface LoadingInterface {
  show?: boolean;
}

const Loading = ({ show }: LoadingInterface): React.ReactElement | null => {
  if (!show) {
    return null;
  }

  return (
    <div className="container__overlay">
      <div className="container__spinner">
        <svg
          className="container__spinner__icon"
          focusable="false"
          role="presentation"
          aria-hidden="true"
          viewBox="0 0 100 100"
          color="red"
        >
          <circle
            cx={50}
            cy={50}
            fill="none"
            strokeWidth={7}
            r={45}
            strokeDasharray="164.93361431346415 56.97787143782138"
            transform="rotate(243.787 50 50)"
          >
            <animateTransform
              attributeName="transform"
              type="rotate"
              calcMode="linear"
              values="0 50 50;360 50 50"
              keyTimes="0;1"
              dur="6s"
              begin="0s"
              repeatCount="indefinite"
            />
          </circle>
        </svg>
      </div>
    </div>
  );
};

export default Loading;
